<template>
    <div style="height: fit-content; width: 100%;">
    <!-- <div style="position: absolute; left: 0%; top: 93%; margin-left: 30px; width: 92%;"> -->
        <v-flex xs12 style="margin-bottom: 0px;">
            <table class="table table-bordered" :class="isA5Format ? 'a5format' : 'a4format'" border="1" width="100%" 
                style="border-collapse: collapse; margin-right: 2%;">
                <tr align="left">
                    <th>Data</th>
                    <th style="width: auto;">Funcionário</th>
                    <th>Moeda</th>
                    <th>Pág.</th>
                </tr>
                <tr>
                    <td>{{fetchedInvoiceReceipt.created_at | formatDate}}</td>
                    <td>{{getWhoRegisteredName}}</td>
                    <td>{{fetchedInvoiceReceipt.sell.type_currency.name}}</td>
                    <td>{{currentPage}}/{{totalPage}}</td>
                </tr>
            </table>
        
            <template v-if="!isA5Format">
                <br>
            </template>

            <table class="table table-bordered" :class="isA5Format ? 'a5format' : 'a4format'" border="1" width="100%" 
                style="border-collapse: collapse; margin-right: 2%">
                <tr>
                    <th align="left" style="width: 12px;">Cod.</th>
                    <th align="left" style="width: 100%;">Descrição</th>
                    <th align="right" style="width: 12px;">Qtd.</th>
                    <th align="right" style="width: 12px;">Preço</th>
                    <th align="right" style="width: 12px;">Desc.</th>
                    <th align="right" style="width: 12px;">Total</th>
                </tr>
                <tr v-for="(item, index) in sellLines" :key=index>
                    <td>{{item.article.code}}</td>
                    <td class="truncate">{{item.article.name}}</td>
                    <td align="right">{{item.sold_quantity}}</td>
                    <td align="right">{{item.sell_price | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                    <td align="right">{{item.discount}}%</td>
                    <td align="right">{{getTotalSellLine(item) | currency('', 2, { thousandsSeparator: '.', decimalSeparator: ',' })}}</td>
                </tr>
            </table>
        </v-flex>
    </div>
</template>

<script>
    export default {
        created () {
            
        },

        data(){
            return {

            }
        },

        props: {
            currentPage: {
                type: Number,
                default: 0,
            },
            totalPage: {
                type: Number,
                default: 0,
            },
            fetchedInvoiceReceipt: {
               type: Object,
               default: () => ({}),
            },
            sellLines: {
                type: Array,
                default: () => [],
            },
            isA5Format: {
                type: Boolean,
                default: false,
            },
            isInvoiceCanceled: {
                type: Boolean,
                default: false,
            },
            invoicePrintLabel: {
                type: String,
                default: ""
            },
        },

        watch: {
            
        },

        computed: {

            getWhoRegisteredName(){
                try{
                    return this.fetchedInvoiceReceipt.sell.made_by_user.name;
                }catch (e) {
                    return '-';
                }
            },

        },

        methods: {

            getTotalSellLine(sellLine){
                let res = 0;
                return sellLine.sell_price * sellLine.sold_quantity;
            },

        }
    }
</script>

<style scoped>

    table.a5format, .a5format tr, .a5format th, .a5format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 11px;
        white-space: nowrap; 
        overflow: hidden; 
        text-overflow: ellipsis;
    }

    table.a4format, .a4format tr, .a4format th, .a4format td{
        border-color: LightGray;
        border-left: none;
        border-right: none;
        padding-left: 10px;
        padding-right: 10px;
        font-size: 14px;
        white-space: nowrap; 
        overflow: hidden; 
        text-overflow: ellipsis;
    }

    table th{
        height: 40px;
    }

    table td{
        height: 30px;
    }

    footer {
        position: fixed;
        bottom: 0;
        margin-bottom: 0;
        font-size: 11px;

        /*margin-top: 8mm;*/
    }
    
    .truncate {
        max-width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
